import { render, staticRenderFns } from "./eventmanagement.vue?vue&type=template&id=b899905c&scoped=true"
import script from "./eventmanagement.vue?vue&type=script&lang=js"
export * from "./eventmanagement.vue?vue&type=script&lang=js"
import style0 from "./eventmanagement.vue?vue&type=style&index=0&id=b899905c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899905c",
  null
  
)

export default component.exports